export default __webpack_public_path__ + "static/iKeepSafe-COPPA-seal-3104a52f8460b19d392f65f910d55aad.png";